import axios from 'axios'

const api = axios.create({
    baseURL: 'https://app-ecd94517-c094-47ad-ab5b-edc6ed386553.cleverapps.io/api/',
    withCredentials: true, // Allow sending cookies
  });
  export default api